export const INITIAL_QUESTION_ID = -1 as number;
export const INITIAL_QUESTION_ANSWERSTACK_ID = -1 as number;
export const INITIAL_ORIGINAL_QUESTION_ANSWERSTACK_ID = -1 as number;
